import React, { useState, forwardRef, useImperativeHandle, useMemo, useEffect } from 'react';
import { Drawer, Button, Steps, Form, Input, notification, Select } from 'antd';
import GroupAPI from '../../../restAPI/GroupAPI';
import validationRules from '../../../assets/validation/rules';
import validateForm from '../../../utils/FormValidation';
import { useSelector } from 'react-redux';

const Context = React.createContext({
  name: 'Default',
});
const { Step } = Steps;
const { TextArea } = Input;
// const onSearch = (value) => {
//   console.log('search:', value);
// };
const StepForm = forwardRef(({ onRefresh }, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { token } = useSelector(state => state.auth);
  const [countryCodes, setCountryCodes] = useState([]);
  const [iSGetCountryCodes, setISGetCountryCodes] = useState(true);
  const [stateCodes, setStateCodes] = useState([]);
  const [iSGetStateCodes, setISGetStateCodes] = useState(true);
  const [payload, setPayload] = useState({
    "_id": "",
    "groupName": "",
    "description": "",
    "countryName": "",
    "countryCode": "",
    "email": "",
    "contactNumber": "",
    "addressLine1": "",
    "addressLine2": "",
    "addressLine3": "",
    "postalZone": "",
    "city": "",
    "stateName": "",
    "stateCode": ""
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if(iSGetCountryCodes){
      getCountryCodes();
      setISGetCountryCodes(false);
    }
    if(iSGetStateCodes){
      getStateCodes();
      setISGetStateCodes(false);
    }
  },);

  const getCountryCodes = async () => {   
    await GroupAPI.getCountryCodes(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          const rows = [];
          res.data.map((rowValue) =>  {
              rows.push({value: rowValue.code, label: rowValue.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') })
          });
          setCountryCodes(rows);

        }
    }).catch(err => {
        console.log("error getting contry codes data :", err.message);
    })
  };

  const getStateCodes = async () => {   
    await GroupAPI.getStateCodes(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          const rows = [];
          res.data.map((rowValue) =>  {
              rows.push({value: rowValue.code, label: rowValue.state})
          });
          setStateCodes(rows);
        }
    }).catch(err => {
        console.log("error getting state codes data :", err.message);
    })
  };

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openViewDrawer: () => {
      setPayload({_id: ref.id});
      getGroupById(ref.id);
      setVisible(true); // Open drawer
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
      if (onRefresh) onRefresh(); // Trigger refresh on close
    },
  }));

  const getGroupById = async (id) => {   
    await GroupAPI.getGroupById(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), id).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          setPayload({
            "_id": res.data._id,
            "groupName": res.data.name,
            "description": res.data.description,
            "countryName": res.data.country.name,
            "countryCode": res.data.country.code,
            "email": res.data.email,
            "contactNumber": res.data.contactNumber,
            "addressLine1": res.data.address.addressLine1,
            "addressLine2": res.data.address.addressLine2,
            "addressLine3": res.data.address.addressLine3,
            "postalZone": res.data.address.postalZone,
            "city": res.data.address.city,
            "stateName": res.data.address.state.name,
            "stateCode": res.data.address.state.code 
          });
        }
    }).catch(err => {
        console.log("error getting group data :", err.message);
    })
  };

  const [api,contextHolder] = notification.useNotification();

  const contextValue = useMemo(
    () => ({
      name: 'Ant Design',
    }),
    [],
  );

  const next = () => setCurrentStep(currentStep + 1);
  const prev = () => setCurrentStep(currentStep - 1);

  const onClose = () => {
    setVisible(false);
    if (onRefresh) onRefresh(); // Trigger refresh on drawer close
    setPayload({
      "_id": "",
      "groupName": "",
      "description": "",
      "countryName": "",
      "countryCode": "",
      "email": "",
      "contactNumber": "",
      "addressLine1": "",
      "addressLine2": "",
      "addressLine3": "",
      "postalZone": "",
      "city": "",
      "stateName": "",
      "stateCode": ""
    });
    setErrors({});
    setCurrentStep(0);
  } 

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules)
    if (!validationResult.isValid) {
        const err = validationResult.errors
        const newErrors = {};
        Object.keys(err).forEach((value) => {
            newErrors[value] = err[value];
        })
        setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
        const keyData = Object.keys(data)[0]
        setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
}

  // Content for each step
  const renderStepContent = () => {
    if (currentStep === 0) {
      return (
        <Form layout="vertical">  
          <Form.Item label="Group Name" validateStatus={errors.groupName ? 'error' : ''} help={errors.groupName || ''} required>
            <Input size="large" disabled name='groupName' value={payload["groupName"]} onChange={(e) => { setPayload(prev => ({...prev, groupName: e.target.value})); const validateData = {groupName: e.target.value}; validateFormData(validateData);}} />
          </Form.Item>
          <Form.Item label="Country" required>
          <Select
            disabled
            showSearch
            name='country'
            value={payload["countryCode"]}
            optionFilterProp="label"
            size='large'
            options={countryCodes}
          />
          </Form.Item>
          <Form.Item label="Description"  >
          <TextArea rows={4} name='description' disabled value={payload["description"]} onChange={(e) => { setPayload(prev => ({...prev, description: e.target.value}));}}/>
          </Form.Item>
         
        </Form>
      );
    } else if (currentStep === 1) {
      return <div> <Form layout="vertical">
        <Form.Item label="Email Address" validateStatus={errors.email ? 'error' : ''} help={errors.email || ''} required>
          <Input size="large" disabled name="email" value={payload["email"]} onChange={(e) => { setPayload(prev => ({...prev, email: e.target.value})); const validateData = {email: e.target.value}; validateFormData(validateData); }}/>
        </Form.Item>

        <Form.Item label="Contact Number" validateStatus={errors.contactNumber ? 'error' : ''} help={errors.contactNumber || ''} required >
          <Input size="large" disabled name="contactNumber" value={payload["contactNumber"]} onChange={(e) => { setPayload(prev => ({...prev, contactNumber: e.target.value})); const validateData = {contactNumber: e.target.value}; validateFormData(validateData);}} />
        </Form.Item>

        <Form.Item label="Address">
          <Form.Item label="Address Line 1">
            <Input size="large" disabled name="addressLine1" value={payload["addressLine1"]} onChange={(e) => { setPayload(prev => ({...prev, addressLine1: e.target.value}));}} />
          </Form.Item>

          <Form.Item label="Address Line 2">
            <Input size="large" disabled name="addressLine2" value={payload["addressLine2"]} onChange={(e) => { setPayload(prev => ({...prev, addressLine2: e.target.value}));}} />
          </Form.Item>

          <Form.Item label="Address Line 3">
            <Input size="large" disabled name="addressLine3" value={payload["addressLine3"]} onChange={(e) => { setPayload(prev => ({...prev, addressLine3: e.target.value}));}} />
          </Form.Item>

          <Form.Item label="Postal Zone">
            <Input size="large" disabled name="postalZone" value={payload["postalZone"]} onChange={(e) => { setPayload(prev => ({...prev, postalZone: e.target.value}));}} />
          </Form.Item>

          <Form.Item label="City Name" validateStatus={errors.city ? 'error' : ''} help={errors.city || ''} required >
            <Input size="large" disabled name="city" value={payload["city"]} onChange={(e) => { setPayload(prev => ({...prev, city: e.target.value})); const validateData = {city: e.target.value}; validateFormData(validateData);}} />
          </Form.Item>

          <Form.Item label="State" required>
          <Select
            disabled
            showSearch
            name="state"
            optionFilterProp="label"
            value={payload["stateName"]}
            size='large'
            options={stateCodes}
          />
          </Form.Item>

          {/* <Form.Item label="State Code" required>
            <Input size="large" name="stateCode" value={payload["stateCode"]} disabled/>
          </Form.Item> */}
        </Form.Item>
      </Form></div>;
    }
    return null;
  };

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="View Group"
        width={700}
        visible={visible}
        onClose={onClose}
        footer={
          <div style={{ textAlign: 'right' }}>
            {currentStep > 0 && (
              <Button style={{ marginRight: 8 }} size="large" onClick={prev}>
                Previous
              </Button>
            )}
            {currentStep < 1 ? (
              <Button type="primary" size="large" onClick={next}>
                Next
              </Button>
            ) : (
              <Button hidden type="primary" size="large">
                Submit
              </Button>
            )}
          </div>
        }
      >
        <Steps current={currentStep}>
          <Step title="General Information" />
          <Step title="Contact Information" />
        </Steps>
        <div style={{ marginTop: 24 }}>{renderStepContent()}</div>

      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
